import gql from 'graphql-tag';

const mutationClockIn = gql`

	mutation ClockIn {
		clockIn {
			id
			user
			in
			out
			paused {
				id
				start
				end
				reason
			}
			isOnBreak
			totalTime
			totalBreakTime
			totalPaidTime
		}
	}

`;

export default mutationClockIn;